import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

export const ConfirmCloseTrustmaticModal = ({
  show,
  onClose,
  onExit,
}: {
  show: boolean;
  onClose: () => void;
  onExit: () => void;
}) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <Modal isOpen={show} isDismissable>
      <Dialog>
        <DialogHeader onClose={onClose} testID="confirm-close-trustmatic">
          {t("Incomplete Verification")}
        </DialogHeader>
        <DialogContent>
          <Trans>
            Are you sure you want to exit the identity verification process?
          </Trans>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onExit}>
            <Trans>Exit</Trans>
          </BasicButton>
          <PrimaryButton onPress={onClose}>
            <Trans>Continue Verification</Trans>
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
};
